// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ================================
// IMPORTS DES SERVICES
// ================================
import { UsageProfileService } from "./usage-profile.service"

// ================================
// EXPORTS DES SERVICES
// ================================
export * from "./usage-profile.service"

// ================================
// REGISTRY DES SERVICES
// ================================
export const usageProfileServiceRegistry = {
    usageProfile: new UsageProfileService(),
} as const

// ================================
// TYPES DU REGISTRY
// ================================
export type UsageProfileServiceRegistry = typeof usageProfileServiceRegistry
